"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserFormDataSerializer = void 0;
const HttpFormDataSerializer_1 = require("../HttpFormDataSerializer");
class BrowserFormDataSerializer extends HttpFormDataSerializer_1.HttpFormDataSerializer {
    canParseObject(obj) {
        return !(obj instanceof Date) && !(obj instanceof File);
    }
    serialize(data) {
        const formData = new FormData();
        this.populateFormData(formData, data);
        return formData;
    }
}
exports.BrowserFormDataSerializer = BrowserFormDataSerializer;
//# sourceMappingURL=BrowserFormDataSerializer.js.map